import { render, staticRenderFns } from "./associatedDoc.vue?vue&type=template&id=69437c0c&scoped=true&"
import script from "./associatedDoc.vue?vue&type=script&lang=js&"
export * from "./associatedDoc.vue?vue&type=script&lang=js&"
import style0 from "./associatedDoc.vue?vue&type=style&index=0&id=69437c0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69437c0c",
  null
  
)

export default component.exports